
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	
	import {
		getAgentOrderCheckRecordList
	} from '@/api/order'

	import {
		nextDay
	} from "@/utils"

	@Component({
		name: 'agency-check-record',
		components: {
			PageFooter,
			PickerDate
		}
	})
	export default class AgencyCheckRecord extends Vue {
		private id: number = +this.$route.query.id;
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		
		private keywords = '';
		
		private filterTime: any = '';
		private filterCheckTime: any = '';
		private selectTime = 0
		private selectTimes = [{
			label: '下单时间',
			value: 0
		}]
		private checkTime = 0
		private checkTimes = [{
			label: '审核时间',
			value: 0
		}]
		private tableloading=false
		private mounted() {
			this.filterTime = this.$route.query.filterTime
			this.getList();
		}


		private changePage(num: number) {
			console.log(num)
			this.pageNo = num;
			this.getList();
		}
		
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}
		
		private clearSearch() {
			this.keywords = ''
			this.pageNo = 1;
			this.filterTime = this.$route.query.filterTime;
			this.filterCheckTime = '';
			this.getList();
		}

		private async getList() {
			try {
				
				let times: any = '';
				if (this.filterTime){
					times = this.filterTime.split('/');
				}
				
				let checkTimes: any = '';
				if (this.filterCheckTime){
					checkTimes = this.filterCheckTime.split('/');
				}
				this.tableloading = true
				const res: any = await getAgentOrderCheckRecordList({
					Keywords:this.keywords,
					MemberId: this.id,
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize,
					AddStartTime: times ? times[0]:'',
					AddEndTime: times ? nextDay(times[1],1):'',
					CheckStartTime: checkTimes ? checkTimes[0]:'',
					CheckEndTime: checkTimes ? nextDay(checkTimes[1],1):'',
				})
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}finally{
				this.tableloading = false
			}
		}

		private async toDetail(id: number) {
			this.$router.push({
				name: 'Agency_Check_Record_Detail',
				query: {
					id: id + '',
					userId: this.id + ''
				}
			})
		}

		private toBack(){
			this.$router.back();
		}
	}
